import { combineReducers } from 'redux';

import clientsAndLocations from './clientsAndLocations';
import bottomGrid from './bottomGrid';
import tasks from './bottomGrid/tasks';
import events from './bottomGrid/events';
import eventsByRfid from './bottomGrid/eventsByRfid';
import contractItems from './bottomGrid/contractItems';
import tasksPane from './pane/tasksPane';

export default combineReducers({
    clientsAndLocations,
    bottomGrid,
    tasks,
    events,
    eventsByRfid,
    contractItems,
    tasksPane,
});
